"use client";

import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { reportUnexpectedError } from "@/lib/errors/from-error";

/**
 * 画面の表示中に起きた例外の代わりに出す案内（`error.tsx` の本体）。
 *
 * @remarks
 * 例外の中身（メッセージ・スタック・digest）はエラーダイアログに積んで全部出す（#456）。
 * ここは「表示できなかった」ことと再試行だけを出す。
 *
 * @param props.error - Next がエラー境界に渡す例外（サーバー側の例外は本文が伏せられ digest だけになる）。
 * @param props.retry - 再試行（`unstable_retry`）。
 */
export function RenderErrorFallback({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  useEffect(() => {
    reportUnexpectedError(error, "render", error.digest ?? null);
  }, [error]);
  return (
    <div className="flex flex-col items-start gap-3 p-6" role="alert">
      <h2 className="text-base font-medium text-destructive">画面を表示できませんでした</h2>
      <p className="text-sm text-muted-foreground">
        エラーの内容はダイアログに出しています。スクリーンショットを撮って問い合わせ先へ送ってください。
      </p>
      <Button type="button" variant="outline" onClick={retry}>
        もう一度表示する
      </Button>
    </div>
  );
}
